/**
 * Configuration status value. Entities with INACTIVE status are not
 * available for selection.
 *
 * Options:
 * - ACTIVE: The entity is active and can be used.
 * - INACTIVE: The entity is not visible in frontend.
 * - ARCHIVED: (tbd)
 */
enum ConfigurationStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
    // ARCHIVED = 'ARCHIVED' --- IGNORE ---
}

export { ConfigurationStatus };
